import { Checkbox, FormControlLabel } from "@mui/material";
import React, { ComponentProps } from "react";

import { IMedicalFormItemConfigProps, IMedicalFormItemProps } from "../../Types/IMedicalFormItemProps";
import BaseComposableFormItem, { IBaseComposableFormItemProps } from "./BaseComposableFormItem";

const CheckBoxFormElement: React.FC<ComponentProps<IBaseComposableFormItemProps["FormElement"]>> = ({
  value,
  onChange,
  disabled
}) => (
  <FormControlLabel
    control={<Checkbox color="primary" />}
    label="Yes"
    labelPlacement="end"
    onChange={(_, newValue) => onChange(newValue ? "true" : null)}
    checked={value == "true"}
    disabled={disabled}
  />
);

const YesCheckboxFormItem: React.FC<IMedicalFormItemConfigProps & IMedicalFormItemProps> = props => (
  <BaseComposableFormItem {...props} FormElement={CheckBoxFormElement} />
);

export default YesCheckboxFormItem;
